import { Injectable } from '@angular/core';
import { UIRouter } from '@uirouter/core';
import { createAccessibilityFutureState } from '@client/app/pages/accessibility/accessibility-future.state';

const ACCESSIBILITY_ROOT_STATE = 'base.customer.domain.accessibility';
const ACCESSIBILITY_FUTURE_STATE_NAME = 'base.customer.domain.accessibility.**';

@Injectable({
    providedIn: 'root',
})
export class AccessibilityStateRegistryService {
    constructor (
        private readonly uiRouter: UIRouter,
    ) {}

    resetAccessibilityStatesForCustomerSwitch (): void {
        const stateRegistry = this.uiRouter.stateRegistry;
        const rootState = stateRegistry.get(ACCESSIBILITY_ROOT_STATE);
        const futureState = stateRegistry.get(ACCESSIBILITY_FUTURE_STATE_NAME);

        const hasConcreteRoot = Boolean(rootState && rootState.name === ACCESSIBILITY_ROOT_STATE);
        const hasFutureState = Boolean(futureState && futureState.name === ACCESSIBILITY_FUTURE_STATE_NAME);

        // Already reset: no concrete states exist and future state is ready for next lazy load.
        if (!hasConcreteRoot && hasFutureState) {
            return;
        }

        try {
            if (hasConcreteRoot) {
                stateRegistry.deregister(ACCESSIBILITY_ROOT_STATE);
            }

            if (hasFutureState) {
                stateRegistry.deregister(ACCESSIBILITY_FUTURE_STATE_NAME);
            }

            if (!stateRegistry.get(ACCESSIBILITY_FUTURE_STATE_NAME)) {
                stateRegistry.register(createAccessibilityFutureState());
            }
        } catch {
            // Never block customer switching if registry operations fail.
        }
    }
}
